function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 41.5C32.3218 41.5 41.5 32.3218 41.5 21C41.5 9.67816 32.3218 0.5 21 0.5C9.67816 0.5 0.5 9.67816 0.5 21C0.5 32.3218 9.67816 41.5 21 41.5Z",
  fill: "#FAFAFA",
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 1,
  y: 1,
  width: 40,
  height: 40
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 41C32.0457 41 41 32.0457 41 21C41 9.9543 32.0457 1 21 1C9.9543 1 1 9.9543 1 21C1 32.0457 9.9543 41 21 41Z",
  fill: "white"
}));

var SvgDiscussionYellow = function SvgDiscussionYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.806 24.7463H16.5821C14.607 24.7463 13 23.1393 13 21.1642V17.5821C13 15.607 14.607 14 16.5821 14H22.6269C24.6019 14 26.209 15.607 26.209 17.5821V21.1642C26.209 23.1393 24.6019 24.7463 22.6269 24.7463H19.4681L17.5866 26.8369C17.5 26.9331 17.3782 26.9851 17.2537 26.9851C17.1998 26.9851 17.1456 26.9754 17.0934 26.9553C16.9201 26.8888 16.806 26.7227 16.806 26.5373V24.7463ZM16.5821 14.8954C15.1258 14.8954 13.8955 16.1256 13.8955 17.582V21.164C13.8955 22.6204 15.1258 23.8506 16.5821 23.8506H17.2537C17.5009 23.8506 17.7015 24.0512 17.7015 24.2984V25.3703L18.9358 23.9988C19.0208 23.9043 19.1417 23.8506 19.2687 23.8506H22.6269C24.0832 23.8506 25.3134 22.6204 25.3134 21.164V17.582C25.3134 16.1256 24.0832 14.8954 22.6269 14.8954H16.5821Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0896 25.8657H24.6418C24.6029 25.8657 24.5659 25.8722 24.5299 25.8816C24.4938 25.8722 24.4569 25.8657 24.4179 25.8657C24.1708 25.8657 23.9702 26.0663 23.9702 26.3135V27.3854L22.7359 26.0139C22.6508 25.9195 22.5299 25.8657 22.403 25.8657H19.7164C19.4693 25.8657 19.2687 26.0663 19.2687 26.3135C19.2687 26.5607 19.4693 26.7613 19.7164 26.7613H22.2035L24.085 28.8519C24.1717 28.9481 24.2935 29.0001 24.4179 29.0001C24.4717 29.0001 24.5261 28.9904 24.5782 28.9703C24.7515 28.9038 24.8657 28.7377 24.8657 28.5523V26.7613H25.0896C27.0646 26.7613 28.6717 25.1542 28.6717 23.1792V19.5971C28.6717 18.2887 28.2411 17.3619 27.3552 16.7634C27.1504 16.6246 26.8719 16.679 26.7335 16.8839C26.5952 17.0887 26.6491 17.367 26.854 17.5054C27.4916 17.9363 27.7761 18.5813 27.7761 19.5971V23.1792C27.7761 24.6355 26.5459 25.8657 25.0896 25.8657Z",
    style: {
      fill: "var(--color-primary)"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiscussionYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/discussion-yellow.82ddfeb9.svg";
export { ForwardRef as ReactComponent };